import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { selectPermissionIndex, showHideFolderPermissionDialog } from '../actions/internalActions';

// Set selectedPermissionIndex when selectPermissionIndex action is dispatched
export const selectPermissionIndexMutator = mutator(selectPermissionIndex, actionMessage => {
    getStore().selectedPermissionIndex = actionMessage.permissionIndex;
});

// This mutator will reset selected permissions index in the folder permissions store.
export const resetPermissionIndexOnCloseDialogMutator = mutator(
    showHideFolderPermissionDialog,
    actionMessage => {
        // When the dialog gets closed then shouldShow will be falsy. Reset at this time.
        if (!actionMessage.shouldShow) {
            getStore().selectedPermissionIndex = 0;
        }
    }
);
